<template>
  <div>
    <v-select
      label="Formas de pago"
      v-model="selectedLocal"
      item-text="nombre"
      item-value="id"
      :items="filteredItems"
      prepend-icon="mdi-cash-register"
    ></v-select>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'FormasPagosSelectComponent',
  model: {
    prop: 'formapagoid',
    event: 'change'
  },
  props: {
    formapagoid: {
      type: Number,
      default: null
    },
    excludeIds: {
      type: Array,
      default: () => []
    }
  },
  async created () {
    await this.onEstablecerDB();
    await this.onEstablecerDefault();
  },
  computed: {
    ...mapGetters('FormasPagos', ['all']),
    selectedLocal: {
      get () {
        return this.formapagoid
      },
      set (value) {
        this.$emit('change', value)
      }
    },
    filteredItems () {
      if (!this.all) return [];
      const excluded = this.excludeIds.map(id => Number(id));
      return this.all.filter(item => {
        const itemId = Number(item.id);
        return !excluded.includes(itemId) || itemId === Number(this.formapagoid);
      });
    }
  },
  methods: {
    ...mapActions('FormasPagos', ['onFetch']),
    ...mapMutations('FormasPagos', ['setAll']),
    async onEstablecerDB () {
      // Verifica si los productos ya están cargados
      if (this.all?.length) return;
      try {
        const aux = this.getFromSession() || await this.onFetch();
        if (aux) this.setAll(aux);
      } catch (error) {
        console.error('Error al cargar las formas de pago:', error);
      }
    },
    onEstablecerDefault () {
      if (this.formapagoid !== null && this.formapagoid !== undefined) return;
      const aux = this.all[0]?.id;
      this.$emit('change', aux)
    },
    getFromSession () {
      const aux = window.sessionStorage.getItem('pag');
      return aux ? JSON.parse(aux) : null;
    }
  }
}
</script>
